import { DeliveryQuickCheckOutReason, ImplantInspectionStage } from './Deliveries';
import { DeliverySetTrayStatus } from './Trays';

export type ImplantInstanceId = string;

type Gs1ParsedData = {
  gtin: string;
  expiry: string;
  lotNumber: string;
};

export type Gs1Data = {
  gs1Id: string;
  tradeItemDescription: string;
  companyName: string;
  artgId: string;
  manufacturerInternalReference: string;
  shortDescription: string;
  gln: string;
};

type Gs1Lookup = {
  status: 'SUCCESS' | 'INVALID' | 'ERROR' | 'NOT_FOUND';
  gs1Data: Gs1Data;
  parsedData: Gs1ParsedData;
};

export type AddImplantToDeliveryResponse = {
  implantInstanceId: ImplantInstanceId;
  deliveryId: string;
  barcode: string;
  implants: Implant[];
};

export type AddImplantImagePathRequest = {
  implantImagesPath: string[];
};

export type GetGS1DataResponse = Gs1Lookup & {
  sadlImplantKitData?: {
    implantKitName: string;
    implantKitCode: string;
    implantKitUss: string;
    implantCount: number;
  };
};

export type DeleteImplantFromDeliveryRequest = {
  implantInstanceId: string;
};

export type DeleteImplantFromDeliveryResponse = {
  implantInstanceId: string;
};

export type AddImplantToDeliveryRequest = {
  barcode: string;
  stage: ImplantInspectionStage;
  tenantName?: string;
};

export type AddImplantImageToHospitalDeliveryResponse = {
  implantImagesPath: string[];
};

type ImplantInspectionResponse = {
  status: DeliverySetTrayStatus;
  createdAt: string;
  createdBy: string;
};

export type ImplantInspections = {
  CHECK_IN?: ImplantInspectionResponse;
  CHECK_OUT?: ImplantInspectionResponse;
  OUTBOUND?: ImplantInspectionResponse;
};

export type Implant = {
  inspection?: ImplantInspections;
  implantInstanceId: ImplantInstanceId;
  barcode: string;
  itemCode?: string;
  gs1Data?: Gs1Data | null;
  crossDeliveryId?: string;
  createdBy?: string;
  turnaroundOrigin?: boolean;
  turnaroundOriginDeliveryId?: number | null;
  turnaroundDestination?: boolean;
  turnaroundDestinationDeliveryId?: number | null;
  turnaroundStage?: null | 'PENDING' | 'COMPLETED' | 'CANCELLED';
  parsedData?: Gs1ParsedData | null;
  implantKitUss?: string;
  implantKitName?: string;
  implantKitCode?: string;
  notificationsSent?: {
    checkout?: number;
  };
  quickCheckedOut?: {
    date: string;
    reason: DeliveryQuickCheckOutReason;
  };
};

export type ImplantsByDelivery = Record<string, Implant[]>;

export type UnscannableImplantPathParams = {
  stage: ImplantInspectionStage;
  deliveryId: string;
};

export const makeImplant = (data: Partial<Implant>): Implant => ({
  inspection: {},
  implantInstanceId: '',
  barcode: '',
  gs1Data: undefined,
  crossDeliveryId: undefined,
  createdBy: undefined,
  turnaroundOrigin: false,
  turnaroundDestination: false,
  ...data,
});

export enum SkipImplantCheckInReason {
  LimitedTime = 'limitedTime',
  WithoutSaviCapture = 'withoutSaviCapture',
  SalesRep = 'salesRep',
  ProcessedUsingRfidMachine = 'processedUsingRfidMachine',
  NoImplantReturned = 'noImplantReturned',
}

export enum SkipImplantCheckOutReason {
  LimitedTime = 'limitedTime',
  WithoutSaviCapture = 'withoutSaviCapture',
  SalesRep = 'salesRep',
  ProcessedUsingRfidMachine = 'processedUsingRfidMachine',
  NoImplantReturned = 'noImplantReturned',
}
